<template>
  <div class="container beautity_said" v-if="info && Object.keys(info).length">
    <div
      class="page_top headerInfo"
      :style="{
        backgroundImage:
          'url(' +
          (info.backimg ? info.backimg : 'linear-gradient(225deg, #faa3b0 0%, #fa908e 100%)') +
          ')'
      }"
    >
      <div class="flex-js-ac">
        <div class="avatar flex-ac">
          <!-- 用户头像和名称 -->
          <img
            :src="info.head"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorHeadImg
                img.onerror = null
              }
            "
            alt=""
          />
          <p class="f18">{{ info.name }}</p>
        </div>
        <div class="follow">
          <!-- 关注按钮 -->
          <button class="follow-btn f14" :class="{ graybtn: info.isfollow == 1 }" @click="follow">
            {{ info.isfollow == 1 ? '取消关注' : '关注' }}
          </button>
        </div>
      </div>
      <div class="flex-ac mt14 f13 mb10" style="color: #ffffff;">
        <p class="mr30">
          <span class="f13 fb">{{ info.fansnum }}</span>
          <span style="color: rgba(255, 255, 255, .76)">关注</span>
        </p>
        <p>
          <span class="f12 fb">{{ info.likesnum }}</span>
          <span style="color: rgba(255, 255, 255, .76)">获赞与收藏</span>
        </p>
      </div>
      <div class="description f12">
        <!-- 两行字的描述 -->
        {{ info.selfintroduction }}
      </div>
    </div>
    <div class="searchbox" @click="search">
      <div class="search flex-1 flex-js-ac">
        <div class="inp">搜索你要查找的内容</div>
        <div class="searchBtn f14">
          <van-icon name="search" color="#ffffff" size="0.2rem" />
          搜索
        </div>
      </div>
    </div>
    <div>
      <!-- 页面内容 -->
      <Scroller
        :is-loading-data.sync="loading"
        :is-finished-data.sync="finished"
        @on-infinite="onInfinite"
        class="my_scroller"
        ref="my_scroller"
        type="infinite"
      >
        <van-tabs
          v-model="tagsIndex"
          @change="tagsHandle"
          :ellipsis="false"
          line-width="0.24rem"
          line-height="0.03rem"
          title-active-color="#292929"
          title-inactive-color="#666666"
          v-if="navlist.length > 1"
        >
          <van-tab v-for="(item, index) of navlist" :key="index" :title="item.title"></van-tab>
        </van-tabs>
        <div class="video_box flex-ac flex-w">
          <div v-for="(item, index) of list" class="video_item" @click="videoDetail(item)">
            <img v-lazy="item.coverimg" alt="" />
            <p class="f11">
              <van-icon size="0.16rem" name="/static/images/community/video2.png" />
              <span>{{ item.playnum }}</span>
            </p>
          </div>
        </div>
      </Scroller>
    </div>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
export default {
  name: 'beautitysaid',
  components: {
    Scroller
  },
  data() {
    return {
      tagsIndex: 0,
      info: {},
      navlist: [],
      list: [],
      loading: false,
      finished: false,
      pageno: 0,
      pagesize: 20
    }
  },
  beforeMount() {
    console.log(this.loading, this.finished)
    this.getData()
  },
  methods: {
    getData: function() {
      this.tagsHandle(0)
    },
    tagsHandle: function(index) {
      this.tagsIndex = index
      this.pageno = 0
      this.list = []
      this.onInfinite()
    },
    getVideoList: function() {
      var url =
        this.$ajax.getMainPageInfo_URL +
        `?pageno=${this.pageno}&pagesize=${this.pagesize}&type=down&id=${
          this.navlist.length ? this.navlist[this.tagsIndex].id : 0
        }`
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.info = res.data.data
          this.navlist = res.data.data.classifyList
          if (this.navlist.length) {
            this.navlist.unshift({ id: '', title: '全部' })
          }
          if (this.pageno === 1) {
            this.list = res.data.data.videoList.list
            this.refresh = false
          } else {
            this.list = this.list.concat(res.data.data.videoList.list)
          }
          this.loading = false
          if (res.data.data.videoList.list.length < this.pagesize) {
            this.finished = true
          } else {
            this.finished = false
          }
        }
      })
    },
    onInfinite: function() {
      this.loading = true
      this.finished = false
      this.pageno++
      this.getVideoList()
    },
    search: function() {
      this.$router.push({
        path: '/bs'
      })
    },
    videoDetail: function(item) {
      this.$router.push({
        path: '/beautitysaiddetail',
        query: {
          beautitysaidid: item.id,
          index: item.index,
          cateid: this.navlist.length ? this.navlist[this.tagsIndex].id : 0
        }
      })
    },
    follow: function() {
      var url = this.$ajax.follow_URL
      var paramsData = {
        isfollow: this.info.isfollow == 0 ? 1 : 0
      }
      this.$customRequestAjax.post(url, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.info.isfollow = this.info.isfollow == 0 ? 1 : 0
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// .container {
//   display: flex;
//   flex-direction: column;
//   height: 100vh;
// }

.page_top {
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100%;
  padding: 0.46rem 0.15rem 0.2rem;
  position: relative;
  height: 2.19rem;
  > div {
    position: relative;
    z-index: 1;
  }
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    display: block;
    background: linear-gradient(
      0deg,
      rgba(109, 106, 106, 0.7) 0%,
      rgba(109, 106, 106, 0.1) 70%,
      rgba(109, 106, 106, 0) 100%
    );
  }
}

.avatar {
  /* 用户头像和名称的样式 */
  img {
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 50%;
    margin-right: 0.15rem;
  }
  p {
    color: #ffffff;
    font-weight: bold;
  }
}

.follow {
  /* 关注按钮的样式 */
  .follow-btn {
    width: 0.8rem;
    height: 0.28rem;
    background: linear-gradient(270deg, #fc5f80 0%, #fc0324 100%);
    border-width: 0;
    outline: none;
    border-radius: 0.14rem;
    line-height: 0.28rem;
    color: #ffffff;
    display: block;
    &.graybtn {
      background: #ffffff1f;
      border: 0.01rem solid #ffffff;
    }
  }
}
.description {
  /* 两行字的描述的样式 */
  color: #ffffff;
}
.searchbox {
  padding: 0.07rem 0;
  padding-left: 0.11rem;
  background-color: #ffffff;
}
.search {
  /*width: 3.23rem;*/
  margin-right: 0.1rem;
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.13rem;
  background: #ffffff;
  border-radius: 0.15rem;
  border: 0.01rem solid #fc0324;
  color: #999999;
  position: relative;
  .searchicon {
    font-size: 0;
    position: absolute;
    width: 0.2rem;
    height: 0.2rem;
    left: 0.1rem;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    /*overflow: hidden;*/
    .van-icon-search {
      color: transparent;
      font-weight: 600;
      font-size: 0.2rem;
      height: 100%;
      background: url('../../assets/images/search3.png') no-repeat center;
      background-size: 100%;
    }
  }
  .inp {
    border: 0.01rem solid transparent;
    background: transparent;
    border-radius: 0.15rem;
    height: 0.3rem;
    line-height: 0.3rem;
    padding-left: 0.1rem;
    font-size: 0.13rem;
    color: #999999;
    -webkit-transition: all 0.35s;
    transition: all 0.35s;
    margin-right: 0.1rem;
  }
  .searchBtn {
    color: #ffffff;
    background: linear-gradient(92deg, #fc0324 0%, #f63a66 100%);
    border-radius: 0.15rem;
    flex-wrap: nowrap;
    padding: 0 0.12rem;
    height: 0.29rem;
    line-height: 0.3rem;
    .van-icon-search {
      position: initial;
      background: none;
      transform: translateY(0);
      vertical-align: middle;
      margin-right: 0.02rem;
    }
  }
}
.video_box {
  margin: 0.1rem 0.07rem;
}
.video_item {
  width: 33.33%;
  position: relative;
  margin-bottom: 0.1rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 93%;
    height: 0.3rem;
    margin: auto;
    display: block;
    border-radius: 0 0 0.04rem 0.04rem;
    background: linear-gradient(
      0deg,
      rgba(109, 106, 106, 0.7) 0%,
      rgba(109, 106, 106, 0.1) 70%,
      rgba(109, 106, 106, 0) 100%
    );
  }
  > img {
    width: 93%;
    height: 1.5rem;
    object-fit: cover;
    border-radius: 0.04rem;
    margin: auto;
  }
  p {
    position: absolute;
    left: 0.09rem;
    bottom: 0;
    color: #ffffff;
    z-index: 1;
    span {
      vertical-align: super;
    }
  }
}
.mt14 {
  margin-top: 0.14rem;
}
.mb10 {
  margin-bottom: 0.1rem;
}
.pt20 {
  padding-top: 0.2rem;
}
.mr30 {
  margin-right: 0.3rem;
}
</style>

<style>
.beautity_said {
  .van-tabs__line {
    bottom: 0.2rem;
  }
  .van-tabs__nav {
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community-beautitysaid/index.vue